export default "__VITE_ASSET__2iMlJ1v___"